import * as React from 'react';

import { ImportEvent, ImportStatus } from '../ImportEventsReducer';

export interface ImportSummaryPageProps {
    eventsList: Array<ImportEvent>;
}

export const ImportSummaryPage = (props: ImportSummaryPageProps) => {
    const renderFailedEvents = (failedEvents: number) => {
        if (failedEvents > 0) {
            return <p id="importFailedStatus" className="text-center">{failedEvents} Events failed to import</p>
        } else {
            return null;
        }
    }

    if (props.eventsList.length === 0) {
        return null;
    }

    const successEvents = props.eventsList.filter(x => x.IsImporting == ImportStatus.Imported).length;
    const failedEvents = props.eventsList.filter(x => x.IsImporting == ImportStatus.FailedImport);

    const icon = failedEvents.length > 0 ? "fas fa-times-circle" : "fas fa-check-circle";
    let iconClass = failedEvents.length > 0 ? "text-danger" : "text-success";
    iconClass = "text-center " + iconClass;

    return <div
        className="text-center">
        <p
            style={{ fontSize: 100 + 'px' }}
            className={iconClass}>
            <i
                className={icon}
                aria-hidden="true"></i>
        </p>
        <p id="importSuccessStatus" className="text-center">{successEvents} Events imported successfully</p>
        {renderFailedEvents(failedEvents.length)}
    </div>
}
